import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { activeRoutes } from './utils/adminMenu';
import AdminDashboard from './pages/admin/admindashboard/admindashboard';
import AdminLogin from './pages/admin/adminlogin/adminlogin';
import AdminProfile from './pages/admin/adminprofile';
import AdminChangePassword from './pages/admin/changepassword';
import AddDoctor from './pages/admin/doctor/addoctor';

import Home from './pages/user/home/home';
import LogIn from './pages/user/login/login';
import SignUp from './pages/user/signup/signup';
import FindDoctors from './pages/user/finddoctors/finddoctors';
import UserProfile from './pages/user/profile/profile';
import Address from './pages/user/address';
import DoctorsCriteria from './pages/user/doctorscriteria/doctorscriteria';
import DoctorDetails from './pages/user/doctordetails/doctordetails';
import Medicine from './pages/user/medicine/medicine';
import MedicineDetails from './pages/user/medicinedetails/medicinedetails';
import BrowseBySurgeries from './pages/user/surgeries/browsebysurgery/browsesurgeries';
import ServicesPerSurgery from './pages/user/surgeries/servicespersurgery/servicespersurgery';
import BookSurgery from './pages/user/surgeries/booksurgery/booksurgery';
import ChangePassword from './pages/user/changepassword';
import MyAppointmentList from './pages/user/myappointment';
import AppointmentDetailsPage from './pages/user/appointmentdetails/appointmentdetails';
import Labtest from './pages/user/labtest/labtest.page';
import CartPage from './pages/user/cart/cart.page';
import MyRequests from './pages/user/myrequests/myrequest.page';
import RequestDetailsUserLayout from './pages/user/myrequests/requestdetails.userlayout';
import RequestDetailsAdminLayout from './pages/admin/requests/requestdetails.adminlayout';
import { encryptStorage } from './utils/storage';
import { USER_ROLES } from './utils/constants';

const AuthRoutes = () => {
    const user = encryptStorage.getItem('user-info');
    const userToken = encryptStorage.getItem('user-info');
    if (!user || !userToken) {
        return <Navigate to="/" />;
    }
    return <Outlet />;
};

const PatientRoutes = () => {
    const user = encryptStorage.getItem('user-info');
    if (user.role !== USER_ROLES.PATIENT) {
        return <Navigate to="/" />;
    }
    return <Outlet />;
};

const AdminRoutes = () => {
    const user = encryptStorage.getItem('user-info');
    if (user.role === USER_ROLES.PATIENT) {
        return <Navigate to="/" />;
    }
    return <Outlet />;
};

const AppRoutes = () => {
    return (
        <>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/login' element={<LogIn />} />
                <Route path='/signup' element={<SignUp />} />
                <Route path='/finddoctors' element={<FindDoctors />} />
                <Route path='/finddoctors/:criteria' element={<DoctorsCriteria />} />
                <Route path='/finddoctors/:criteria/:doctorId' element={<DoctorDetails />} />
                <Route path='/medicine' element={<Medicine />} />
                <Route path='/medicinedetails/:id' element={<MedicineDetails />} />
                <Route path='/surgeries/' element={<BrowseBySurgeries />} />
                <Route path='/labtest/' element={<Labtest />} />
                <Route path='/place-order/' element={<CartPage />} />
                <Route
                    path='/servicespersurgery/:id'
                    element={<ServicesPerSurgery />}
                />
                <Route path='/surgerybookings/:id' element={<BookSurgery />} />
                <Route element={<AuthRoutes />}>
                    <Route element={<PatientRoutes />}>
                        <Route path='/myprofile' element={<UserProfile />} />
                        <Route path='/myappointments' element={<MyAppointmentList />} />
                        <Route path='/myappointments/:apptId' element={<AppointmentDetailsPage />} />
                        <Route path='/myaddress' element={<Address />} />
                        <Route path='/change-password' element={<ChangePassword />} />
                        <Route path='/my-requests/' element={<MyRequests />} />
                        <Route path='/my-requests/:requestId' element={<RequestDetailsUserLayout />} />
                    </Route>
                    <Route element={<AdminRoutes />}>
                        <Route path='/admin/login' element={<AdminLogin />} />
                        <Route path='/admin' element={<AdminDashboard />} />
                        <Route path='/admin/profile' element={<AdminProfile />} />
                        <Route path='/admin/change-password' element={<AdminChangePassword />} />
                        <Route path='/admin/doctors/:page/:userId?' element={<AddDoctor />} />
                        <Route path='/admin/appointments/:apptId' element={<AppointmentDetailsPage />} />
                        <Route path='/admin/requests/:requestId' element={<RequestDetailsAdminLayout />} />
                        {
                            activeRoutes.map(ar => <Route key={ar.text} path={ar.path} element={<ar.component />} />)
                        }
                    </Route>
                </Route>
            </Routes>
        </>
    );
};

export default AppRoutes;